/**
 * Applies a multiple choice value to the current value array, taking into account the maximum number of options allowed.
 *
 * @param {Array} currentValue - The current value array.
 * @param {*} optionValue - The value to be added to the array.
 * @param {boolean} select - Indicates whether the option should be selected.
 * @param {Object} [options] - Additional options.
 * @param {number} [options.maxOptions=1] - The maximum number of options allowed.
 * @return {Array} The updated value array.
 */
export function applyMultipleChoiceValue(currentValue, optionValue, select, options = {}) {
    const { maxOptions, validOptions } = options,
        filterValidOptions = (value) => (validOptions ? validOptions.includes(value) : true);

    let nextValue = [...(currentValue ?? [])].filter(filterValidOptions);
    if (maxOptions) {
        nextValue = nextValue.slice(-maxOptions);
    }

    if (maxOptions && maxOptions == 1 && select) {
        nextValue = [optionValue];
    } else if (maxOptions && nextValue.length >= maxOptions && select) {
        nextValue = [...nextValue];
    } else {
        nextValue = nextValue.filter((value) => value != optionValue);
        if (select) {
            nextValue.push(optionValue);
        }
    }

    return nextValue.filter(filterValidOptions);
}
